module.exports = __webpack_public_path__ + "img/bo.249008a6.svg";